import { useMemo, useState } from 'react';

import withPulse from 'components/Decorators/withPulse';
import ErrorNotFound from 'components/ErrorNotFound';
import Layout from 'components/Layout';
import { checkSpecialMarketingPage } from 'constants/main';
import usePageSlug from 'hooks/usePageSlug';
import AuthWrapper from 'providers/AuthWrapper';
import GlobalProviders from 'providers/GlobalProviders';
import useLandingPropsStore from 'stores/landingPropsStore';
import { getDropdownLanguagesList } from 'utils/getFooterDropdownLanguages';

function NotFoundPage() {
  const [pageData] = useState<{ loading: boolean; data?: any }>({
    loading: true,
  });
  const screenName = useLandingPropsStore(x => x.screenName);
  const { slug } = usePageSlug();

  // needs for turn on/off replay feature (the user user_storage_data)
  const isPartnership =
    checkSpecialMarketingPage(screenName) || pageData?.data?.category === 'partnership';

  const storageDataUnits = {
    isStorageFeature: !pageData.loading && !isPartnership,
    screenName,
    isPartnership,
  };

  const { data } = pageData;

  const dropdownLanguagesList = useMemo(() => getDropdownLanguagesList(slug), [slug]);

  return (
    <GlobalProviders
      isLocalized={false}
      dropdownLanguagesList={dropdownLanguagesList}
      slug={slug}
      dataFetched
    >
      <AuthWrapper storageDataUnits={storageDataUnits}>
        <Layout {...data}>
          <ErrorNotFound />
        </Layout>
      </AuthWrapper>
    </GlobalProviders>
  );
}

export default withPulse(NotFoundPage);
